/**
 * Accordions Module
 * Accordion.js implementations for various accordion types
 */

import Accordion from "accordion-js";
import { isMobile, isTab } from "./utils.js";

export function initAccordions() {
  // initVisiMisiAccordions();
  // initBasicAccordions();
  initFaqAccordions();
  // initAboutFilosofiAccordions();
}

function initVisiMisiAccordions() {
  const accordionsVisiMisi = document.querySelectorAll(".cardVisiMisiAccordion");
  accordionsVisiMisi.forEach((accordion) => {
    new Accordion(accordion, {
      duration: 400,
      showMultiple: true,
      openOnInit: [0, 1],
    });
  });
}

function initBasicAccordions() {
  const basicAccordions = document.querySelectorAll(".basicAccordions");
  basicAccordions.forEach((accordion) => {
    new Accordion(accordion, {
      duration: 400,
      showMultiple: true,
    });
  });
}

function initFaqAccordions() {
  const faqAccordions = document.querySelectorAll(".faqAccordions");
  faqAccordions.forEach((accordion) => {
    new Accordion(accordion, {
      duration: 400,
      showMultiple: false,
      openOnInit: [0],
    });
  });
}

function initAboutFilosofiAccordions() {
  const accordionsAboutFilosofi = document.querySelectorAll(".cardAboutFilosofi");

  accordionsAboutFilosofi.forEach((accordion) => {
    const accordionInstance = new Accordion(accordion, {
      duration: 400,
      showMultiple: false,
    });

    if (!isMobile() && !isTab()) {
      // Disable click events
      const headers = accordion.querySelectorAll(".ac-header");
      headers.forEach((header) => {
        header.replaceWith(header.cloneNode(true));
      });

      // Add hover events
      const newHeaders = accordion.querySelectorAll(".ac-header");
      newHeaders.forEach((header, index) => {
        let hoverTimeout;

        header.addEventListener("mouseenter", () => {
          clearTimeout(hoverTimeout);
          accordionInstance.open(index);
        });

        header.addEventListener("mouseleave", () => {
          hoverTimeout = setTimeout(() => {
            accordionInstance.close(index);
          }, 300);
        });

        // Prevent closing when hovering over content
        const panel = header.nextElementSibling;
        if (panel) {
          panel.addEventListener("mouseenter", () => {
            clearTimeout(hoverTimeout);
          });

          panel.addEventListener("mouseleave", () => {
            hoverTimeout = setTimeout(() => {
              accordionInstance.close(index);
            }, 300);
          });
        }
      });
    }
  });
}
